import { Component } from '@angular/core';

@Component({
  selector: 'app-about-volkstheater',
  templateUrl: './about-volkstheater.component.html',
  styleUrls: ['./about-volkstheater.component.less'],
})
export class AboutVolkstheaterComponent {

}
